import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '@env/environment';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { TippyModule } from '@ngneat/helipopper';

import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared';
import { AppComponent } from './app.component';
import { metaReducers, ROOT_REDUCERS } from './shared/state';
import { HttpClientModule } from '@angular/common/http';
import { AppInitializerService } from './app-initializer.service';
import { ToastrModule } from 'ngx-toastr';
import { ServiceWorkerModule } from '@angular/service-worker';
import { GridModule } from '@grid/grid.module';
import { ApplicationInsightsService } from './application-insights.service';
import { GlobalErrorHandlerService } from './global-error-handler.service';
import { ReportModule } from './report/report.module';
import { CustomRouteReuseStrategy } from '@shared/utils/custom-route-reuse-strategy';

function initializeApp(appInitializerService: AppInitializerService): any {
  return () => appInitializerService.init();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,

    // internals
    SharedModule.forRoot(),
    AuthModule.forRoot(),
    GridModule.forRoot(),

    // externals
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      tapToDismiss: true,
      enableHtml: true,
    }),
    StoreModule.forRoot(ROOT_REDUCERS, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      name: 'NgRx Lautec DPR',
      maxAge: 25,
      logOnly: environment.production,
    }),
    TippyModule.forRoot({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: {
          theme: 'material',
          arrow: false,
          animation: 'scale',
          trigger: 'mouseenter',
          offset: [0, 5],
        },
      },
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      // When not explicit, enabled: true by default
      enabled: environment.enableSW,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    ReportModule,
  ],
  providers: [
    ApplicationInsightsService,
    AppInitializerService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitializerService],
      multi: true,
    },
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
